import { EncryptionRestrictionEntity } from '../entities';
import { authResource } from './Auth';
export const EncryptionDRMResource = authResource({
    path: '/encryptions/:encryptionId/drm/:drmId?',
    schema: EncryptionRestrictionEntity
}).extend('update', {
    body: {
        copyAllowed: false,
        decryptsPerUser: 0,
        forwardAllowed: false,
        linkedSessionsRequired: false,
        printAllowed: false,
        saveAllowed: false,
        sunriseDTTM: null,
        sunsetDTTM: null
    },
    schema: undefined
});
